module.exports = __webpack_public_path__ + "img/download-nt-uat-backup.c4c0e445.png";